/* eslint-disable react-hooks/exhaustive-deps */
import {
  Icon,
  IconButton,
  MenuItem,
  Snackbar,
  SnackbarContent,
  TextField,
} from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";
import CheckCircle from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import Error from "@material-ui/icons/Error";
import axios from "axios";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";

import { COOKIE_TOKEN } from "../redux/authentication";
import * as cookies from "../ultis/cookies";

const LIMIT = 20;

const styles = (theme) => ({
  dropdown: {
    height: "200px",
    overflow: "auto",
    padding: 0,
    marginTop: "5px",
    display: "block",
    zIndex: 2,
    backgroundColor: "#f9f9f9",
    position: "absolute",
    boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.19)",
  },
  input: {
    minWidth: "100%",
  },
  active: {
    backgroundColor: "rgba(0,0,0,0.2)",
  },
  ghost: {
    backgroundColor: "rgba(0,0,0,0.1)",
  },
});

const DrawerExtension = React.memo(function DrawerExtension({
  classes,
  label,
  value,
  getSearchValues,
  getOptionLabel,
  agentId,
  extensionStatus,
}) {
  const [text, setText] = useState("");
  const [currentOption, setCurrentOption] = useState(value); // current value
  const [isShow, setShow] = useState(false);
  const [isMouseOver, setMouseOver] = useState(false);
  const [count, setCount] = useState(LIMIT);
  const [options, setOptions] = useState([]); // list data
  const [isLoadingListOptions, setIsLoadingListOptions] = useState(false);

  const [openReload, setOpenedReload] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(""); // error message

  const [isCheckingExtension, setIsCheckingExtension] = useState(false); // loading when choose an extension

  const getData = useCallback(
    debounce(async (count, text) => {
      setIsLoadingListOptions(true);
      const res = await axios.get("/cloud-pbx/extension", {
        headers: {
          Authorization: cookies.get(COOKIE_TOKEN),
        },
        params: {
          filter: {
            order: "createdAt DESC",
            limit: count,
            where: {
              agentView: true,
              ...getSearchValues(text),
            },
            fields: {
              id: true,
              name: true,
              type: true,
              username: true,
              extensionName: true,
            },
          },
        },
      });
      setOptions(res.data);
      setIsLoadingListOptions(false);
    }, 300),
    []
  );

  //init, when change count, text need update data
  useEffect(() => {
    getData(count, text);
  }, [count]);

  // scroll to bottom handler
  const scrollHandler = (e) => {
    const bottom =
      Math.abs(
        e.target.scrollHeight - (e.target.scrollTop + e.target.clientHeight)
      ) <= 1;

    if (bottom) setCount((prev) => prev + LIMIT);
  };

  const changeExtensionOfAgentHandler = (newExtension) => {
    setIsCheckingExtension(true);
    if (agentId) {
      axios
        .put(
          `/call-center/agent/${agentId}`,
          {
            extensionId: newExtension.id,
          },
          {
            headers: {
              Authorization: cookies.get(COOKIE_TOKEN),
            },
          }
        )
        .then((res) => {
          setCurrentOption(newExtension);
          setIsCheckingExtension(false);
          setShow(false);
          setText(getOptionLabel(newExtension));
          setOpenedReload(true);
          setSuccess(true);
        })
        .catch((error) => {
          setIsCheckingExtension(false);
          const message =
            error?.response?.data?.error?.message ||
            error?.message ||
            "Có lỗi xảy ra";
          setError(message);
        });
    } else {
      setError("Không xác định được agentId");
      setIsCheckingExtension(false);
      setShow(false);
    }

    setMouseOver(false);
  };

  return (
    <div style={{ position: "relative" }}>
      <TextField
        style={{ width: 190 }}
        label={label}
        value={isShow ? text : getOptionLabel(currentOption || value)}
        onChange={(e) => {
          setText(e.target.value);
          e.persist();
          getData(count, e.target.value);
        }}
        InputProps={{
          style: {
            color: "white",
          },
          spellCheck: "false",
          endAdornment: (
            <>
              {value && !isShow && extensionStatus !== null && (
                <>
                  {extensionStatus ? (
                    <span
                      style={{
                        fontSize: "13px",
                        color: "#267213",
                        fontWeight: 600,
                      }}>
                      ON
                    </span>
                  ) : (
                    <span
                      style={{
                        fontSize: "13px",
                        color: "#ff4d4f",
                        fontWeight: 600,
                      }}>
                      OFF
                    </span>
                  )}
                </>
              )}
              {isLoadingListOptions && (
                <CircularProgress
                  style={{
                    color: "white",
                    width: "1.1rem",
                    height: "1.1rem",
                  }}
                />
              )}
            </>
          ),
        }}
        InputLabelProps={{
          style: {
            color: "white",
          },
        }}
        autoComplete="off"
        onFocus={(e) => {
          e.preventDefault();
          setText(getOptionLabel(currentOption || value));
          setShow(true);
        }}
        onBlur={() => {
          // nếu move chuột ra khỏi list options
          if (!isMouseOver) {
            setText("");
            setShow(false);
          }
        }}
      />
      {isCheckingExtension && (
        <div
          style={{
            width: 190,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className={classes.dropdown}>
          <CircularProgress
            style={{
              width: "2rem",
              height: "2rem",
            }}
          />
        </div>
      )}
      {!isCheckingExtension && options && options.length > 0 && isShow && (
        <div
          style={{ width: 190 }}
          className={classes.dropdown}
          onMouseOver={() => {
            setMouseOver(true);
          }}
          onMouseOut={() => {
            setMouseOver(false);
          }}
          onScroll={scrollHandler}>
          {options.map((val, index) => (
            <MenuItem
              className={
                (currentOption || value) &&
                (currentOption || value).id === val.id
                  ? classes.active
                  : ""
              }
              key={index}
              value={val.id}
              onClick={() => changeExtensionOfAgentHandler(val)}>
              {getOptionLabel(val)}
            </MenuItem>
          ))}
        </div>
      )}

      <Snackbar
        open={openReload}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}>
        <SnackbarContent
          style={{ backgroundColor: "#ffa000", color: "white" }}
          message={"Thao tác cần reload lại trang!"}
          action={
            <IconButton
              onClick={() => window.location.reload()}
              style={{ color: "white" }}>
              <Icon>cached</Icon>
            </IconButton>
          }
        />
      </Snackbar>

      <Snackbar
        open={success}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        autoHideDuration={2000}
        onClose={() => setSuccess(false)}>
        <SnackbarContent
          style={{ backgroundColor: green[600] }}
          message={
            <>
              <CheckCircle /> <span>Thực hiện thành công</span>
            </>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={() => setSuccess(false)}>
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>

      <Snackbar
        open={Boolean(error)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        autoHideDuration={2000}
        onClose={() => setError("")}>
        <SnackbarContent
          style={{ backgroundColor: "#f72048" }}
          message={
            <>
              <Error /> <span>Thực hiện thất bại</span>
              <p>{error}</p>
            </>
          }
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={() => setError("")}>
              <CloseIcon className={classes.icon} />
            </IconButton>,
          ]}
        />
      </Snackbar>
    </div>
  );
});

export default withStyles(styles)(DrawerExtension);
